export default __webpack_public_path__ + "static/desktop_16-9ffe24c9c2de93dbc5a7508cddd2b2b4.webp";